import React from "react";

// Maps a confidence score (0-1) to a dot color + tooltip, per io-schema.md
// § Confidence Scoring:
//   1.00        -> green (exact match)
//   0.90-0.99   -> light-green (minor inference)
//   0.70-0.89   -> yellow (medium confidence, soft flag)
//   < 0.70      -> red (low confidence, required resolution)
function confidenceClass(c) {
  if (c == null) return "conf-none";
  if (c >= 1.0) return "conf-green";
  if (c >= 0.9) return "conf-light-green";
  if (c >= 0.7) return "conf-yellow";
  return "conf-red";
}

function confidenceLabel(c) {
  if (c == null) return "No confidence score";
  const pct = Math.round(c * 100);
  let level;
  if (c >= 1.0) level = "Exact match";
  else if (c >= 0.9) level = "High confidence (minor inference)";
  else if (c >= 0.7) level = "Medium confidence — verify";
  else level = "Low confidence — review required";
  return `${level} (${pct}%)`;
}

/**
 * ConfidenceIndicator — small colored dot with hover tooltip showing the
 * exact confidence value.
 *
 * @param {{ confidence: number|null }} props
 */
export default function ConfidenceIndicator({ confidence }) {
  const cls = confidenceClass(confidence);
  const title = confidenceLabel(confidence);
  return (
    <span
      className={`confidence-indicator ${cls}`}
      title={title}
      aria-label={title}
      role="img"
    >
      ●
    </span>
  );
}

export { confidenceClass, confidenceLabel };